import PropTypes from "prop-types";

import { Grid, Paper, Typography } from "@mui/material";

import { formatDate } from "@/features/shared";

export const GeneralInformationSection = ({ purchaseReturn }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">
            Informasi Retur Pembelian
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Nomor Retur
          </Typography>
          <Typography variant="body1">
            {purchaseReturn.referenceNumber}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(purchaseReturn.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Outlet Peretur
          </Typography>
          <Typography variant="body1">
            {purchaseReturn.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          {/* Plain text, not a link: the goods receipt belongs to the returning
              store, so the hub cannot open it. */}
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Retur Dari
          </Typography>
          <Typography variant="body1">
            {purchaseReturn.returnable?.referenceNumber || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Catatan
          </Typography>
          <Typography variant="body1">{purchaseReturn.note ?? "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  purchaseReturn: PropTypes.object.isRequired,
};
